export enum ReportOutputType {
  csv = 'csv',
  xlsx = 'xlsx'
}
